import React, { useEffect, useState, useContext } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";

import './SOA.css';

import Pages from './components/pages/Pages';
import { IconNext } from "./svg/index";
import IconProgressBar from "./components/controls/IconProgressBar";
import LineProgressBar from "./components/controls/LineProgressBar";
import ControlButton from "./components/controls/ControlButton";
import { InitPage, buildTarficacionData } from "./data/Data";
import useToken from "../../hooks/useToken";
import { DataContext, DataProvier } from "./data/DataContext";
import tarificar from './services/Tarficar';
import { buildData, buidDataOportunity, buidDataPayment } from './services/Help';
import Modal from "react-modal";
import http from '../../services/http';
import { endPoints } from '../../utils/constanst';



const SOA = () => {

    const { loading } = useToken();

    useEffect(() => {
        setTimeout(() => {


            const preloader = document.querySelector(".site-preloader");
            if (preloader) {
                preloader.addEventListener("transitionend", (event) => {

                    if (event.propertyName === "opacity") {
                        preloader.parentNode.removeChild(preloader);
                    }
                });
                preloader.classList.add("site-preloader__fade");
            }


        }, 600);


    }, []);

    return (
        <DataProvier loading={loading}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/soa/" component={Layout} />
                    <Redirect to="/micrositio/soa/" />
                </Switch>
            </BrowserRouter>
        </DataProvier>
    );
}

const Layout = ({ location, history }) => {
    const [index, setIndex] = useState(InitPage);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const { SOA, setSOA, changeHandler, init } = useContext(DataContext);
    const esTarificado = (obj, mensaje) => setSOA({ ...SOA, tarificado: obj, mensaje: mensaje });
    const totalPages = 4;
    const textNext = (!SOA.esTelepago && index == 3) ? "¡Pagar ya!" : "Siguiente";
    const switchTypeIcon = [0, 0, 1, 2, 2];

    const save = () => { };
    const decrement = () => {
        if (index !== 0) setIndex(index - 1);
    };
    const increment = (disabled) => {
        if (index <= totalPages) setIndex(index + 1);
    };
    const handleSubmit = () => {
        let result = document.querySelector("form").reportValidity();
        if (index === 1 && result) {
            if (SOA.datasheet) {
                esTarificado(false, '');
                executeTarificar();
            }
        }
        else if (index === 3 && result) {
            paySoa();// create();
        }
        else if (result)
            increment(true);
    };

    const executeTarificar = () => {
        return new Promise((resolve, reject) => {
            let data = buildTarficacionData(SOA);
            SOA.setTarificacion(data);
            const tarificarPlan = tarificar(SOA.idPlan);
            tarificarPlan(data).then(resp => {
                resolve(resp);
                esTarificado(true, '');
                SOA.setCatalogos({ rates: resp.rates });
                increment(true);
            }).catch(error => {
                console.log(error);
                esTarificado(false, error);
                handleShow();
                reject(error);
            });
        })
    }

    const cssControlButton = (index) => {
        switch (index) {
            case 0: return "control-button-soa-only";
            case 4: return "display-none";//return "control-button-soa-only"//return "display-none";
            default: return "";
        }
    }

    const create = () => {
        setSOA({ ...SOA, cargando: true });
        const data = buildData(SOA);
        console.log("🚀 ~ file: SOA.jsx ~ line 123 ~ create ~ data", data)

        return new Promise((resolve, reject) => {
            http(endPoints.createSOA).post(data).then(response => {
                resolve(response);
                setSOA({ ...SOA, guardado: true, cargando: false, numeroSolicitud: response.id });
                increment(true);
            }).catch(error => {
                console.log("🚀 ~ file: SOA.jsx ~ line 129 ~ http ~ error", error)
                reject(error);
                setSOA({ ...SOA, guardado: false, cargando: false });
                increment(true);
            });
        })
    };


    const paySoa = () => {
        setSOA({ ...SOA, cargando: true });
        let searchParams = new URLSearchParams(location.search);
        let src = searchParams.get('source');   
        const data = buildData(SOA,src);

        return new Promise((resolve, reject) => {
            http(endPoints.createSOA).post(data).then(response => {
               setSOA({ ...SOA, guardado: true, cargando: false, numeroSolicitud: response.id });
               increment();

            }).catch(error => {
                reject(error);
                setSOA({ ...SOA, guardado: false, cargando: false });
            });
        })
    }

    const createOportunity = () => {
        const data = buidDataOportunity(SOA);
        return new Promise((resolve, reject) => {
            http(endPoints.CreateOportunitySoaElectronico).post(data).then(response => {
                console.log("🚀 ~ file: SOA.jsx ~ line 178 ~ http ~ response", response);
                resolve(response);
            }).catch(error => {
                console.log("🚀 ~ file: SOA.jsx ~ line 129 ~ http ~ error", error);
                reject(error);
            });
        })
    }



    return (
        <div className="container">
            <div className="layout-soa">
                <div className="mt-50 mb-20">
                    <p className="title" >
                        ¡Solicitá tu Seguro Obligatorio de Automóvil en minutos!
                </p>
                </div>
                <IconProgressBar indexProgress={switchTypeIcon[index]} />
                <LineProgressBar indexProgress={switchTypeIcon[index]} />
                <form action="">
                    <Pages indexProgress={index} />

                    <ControlButton cssButton={cssControlButton(index)}>
                        {index !== 0 &&
                            <button tabindex="-1"
                                className={`control-button-btn-soa prev`}
                                type="button"
                                onClick={decrement}
                            >
                                Regresar
                             </button>
                        }
                        {
                            <button tabindex="-1"
                                className="control-button-btn-soa next"
                                type="button"
                                onClick={handleSubmit}
                            >
                                {textNext}
                                {index <= totalPages && <IconNext width={12} />}
                            </button>
                        }
                    </ControlButton>
                </form>
            </div>
            <Modal className="modal" isOpen={show} show={show} ariaHideApp={false}>
                <div className="modal-title">
                    <span className="txt-title-modal">Información</span>
                </div>
                <div className="modal-body-info">
                    {SOA.mensaje}
                </div>
                <div className="modal-footer">
                    <button className="modal-btn-close" onClick={handleClose}>Cerrar</button>
                </div>
            </Modal>
            <Modal className="modal" isOpen={SOA.cargando} show={SOA.cargando} ariaHideApp={false}>
                <div className="dialog-center-content">
                    <p className="text-center">Guardando...</p>
                </div>
            </Modal>
        </div>

    );
}


export default SOA;
